@if (isGenericMultiHedge) {
  Client
  @for (part of parts; track i; let i = $index) {
    @if (i > 0) {
      /
    }
    @switch (part) {
      @case ('Buys') {
        <span style="color: var(--positive-green)">Buys</span>
      }
      @case ('Sells') {
        <span style="color: var(--negative-red)">Sells</span>
      }
    }
  }
} @else {
  {{ offerStr() }}
}
